<script>
	// Imports
	import { onAuthStateChanged } from "firebase/auth";
	import { slide } from "svelte/transition";

	// import SvelteMarkdown from "svelte-markdown";
	// import { ref, uploadString, getDownloadURL } from 'firebase/storage';
	import {
		doc,
		// collection,
		// addDoc,
		// setDoc,
		getDoc,
		updateDoc,
		// arrayUnion,
		onSnapshot,
		deleteField,
		// serverTimestamp,
	} from "firebase/firestore";
	import { logEvent } from "firebase/analytics";
	import { uiText } from "../lib/uiText.js";
	// import Messageboard from './Messageboard.svelte';
	// import Riddle from './Riddle.svelte';
	import { createEventDispatcher } from "svelte";
	import GameFooter from "./GameFooter.svelte";
	import User from "./User.svelte";
	import { map } from "../lib/map.js";
	import { gamerule } from "../lib/gameRules.js";
	import ScoreGenerator from "./scoreGenerator.svelte";

	const dispatch = createEventDispatcher();

	// Firebase
	export let auth;
	export let db;
	export let analytics;

	// Global
	export let lang;
	export let user;
	export let loader;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader);

	// Local
	let showLangSelector = false;
	let showHelpInfo = false;
	let showGenerator = false;

	let sessionData = {};
	let gameData = {};
	let background = false;

	$: gameData, gameData;

	let hideResult = true;
	let overwriteHide = false;

	onAuthStateChanged(auth, (authUser) => {
		if (authUser) {
			// list of available properties - https://firebase.google.com/docs/reference/js/firebase.User
			user.name = authUser.displayName;
			user.photo = authUser.photoURL;
			user.uid = authUser.uid;
			checkActiveSession(authUser.uid);
		} else {
			loader = true;
			dispatch("state", "login");
			// console.warn("USER IS OUT, I REPEAT, USER IS OUT!");
		}
	});

	async function checkActiveSession(authUID) {
		const actSesSnap = await getDoc(doc(db, "users", authUID));

		if (actSesSnap.exists()) {
			let snapData = actSesSnap.data();
			if (snapData.hasActiveSession) {
				// console.log('has active sessn');
				startListener(snapData.activeSessionID);
			} else if (!snapData.hasActiveSession) {
				// console.log('has NO active sessn');
				startListener(snapData.latestSession);
			}
		} else {
			console.log("No such document!");
		}
	}

	function startListener(listener) {
		const listenTo = listener || user.latestSession;
		const listening = onSnapshot(doc(db, "sessions", listenTo), (doc) => {
			const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
			// console.log(source, ' data: ', doc.data());
			loader = true;
			// sessionData = doc.data();
			// do {
			//     setTimeout(function () {
			//         console.log('wait');
			//     }, 20);
			// } while (source !== 'Server');

			sessionData = doc.data();

			overwriteHide = sessionData.overwriteHide;
			sessionData.startTime = sessionData.session.sessionStart.toDate();
			// console.log(doc.metadata.hasPendingWrites);
			// if (doc.metadata.hasPendingWrites) {
			if (!sessionData.session.sessionEnd) {
				dispatch("state", "game");
				return;
			} else {
				sessionData.endTime = sessionData.session.sessionEnd.toDate();
			}
			// } else {
			// sessionData.endTime = new Date(Date.now());
			// }

			sessionData.duration =
				(sessionData.endTime.getTime() - sessionData.startTime.getTime()) /
				1000;

			sessionData.duration_floor = Math.floor(
				(sessionData.endTime.getTime() - sessionData.startTime.getTime()) /
					1000,
			);

			//   console.log(sessionData.duration_floor);
			//   console.log(sessionData.session.normal_riddles_solved);

			// OLD score_from_normal_riddles
			// sessionData.score_from_normal_riddles =
			// 	sessionData.session.normal_riddles_solved *
			// 	gamerule.points_for_normal_riddle;

			// => NEW score_from_normal_riddles
			sessionData.score_from_normal_riddles = sessionData.session
				.normal_riddles_solved_ids
				? sessionData.session.normal_riddles_solved_ids.length *
					gamerule.points_for_normal_riddle
				: 0;

			// OLD score_from_bonus_riddles
			// sessionData.score_from_bonus_riddles = sessionData.session
			// 	.bonus_riddles_solved
			// 	? sessionData.session.bonus_riddles_solved *
			// 		gamerule.points_for_bonus_riddle
			// 	: 0;

			// => NEW score_from_bonus_riddles
			sessionData.score_from_bonus_riddles = sessionData.session
				.bonus_riddles_solved_ids
				? sessionData.session.bonus_riddles_solved_ids.length *
					gamerule.points_for_bonus_riddle
				: 0;

			// score_bonus_from_time
			if (sessionData.duration_floor <= 7200) {
				sessionData.score_bonus_from_time = Math.round(
					map(sessionData.duration_floor, 900, 7200, 500, 250),
				);
			} else {
				sessionData.score_bonus_from_time = Math.round(
					map(sessionData.duration_floor, 7200, 86400, 250, 100),
				);
			}

			//   console.log(
			//     sessionData.score_bonus_from_time,
			//     sessionData.score_from_normal_riddles
			//   );

			sessionData.durationDays = Math.floor(sessionData.duration / 86400);
			sessionData.durationHours = Math.floor(
				(sessionData.duration % 86400) / 3600,
			);
			sessionData.durationMinutes = Math.floor(
				((sessionData.duration % 86400) % 3600) / 60,
			);
			sessionData.durationSeconds = Math.floor(
				((sessionData.duration % 86400) % 3600) % 60,
			);
			//   console.log(
			//     sessionData.durationDays,
			//     sessionData.durationHours,
			//     sessionData.durationMinutes,
			//     sessionData.durationSeconds
			//   );

			if (sessionData.hints) {
				sessionData.usedHintsArray = Object.keys(sessionData.hints.hintsUsed);
				sessionData.usedHintsTime = 0;
				sessionData.usedHintsCount = 0;

				sessionData.usedHintsArray.forEach((element) => {
					let keys = Object.keys(sessionData.hints.hintsUsed[element]);
					let values = Object.values(sessionData.hints.hintsUsed[element]);
					// console.log(keys, values);
					sessionData.usedHintsCount = sessionData.usedHintsCount + keys.length;

					values.forEach((element) => {
						sessionData.usedHintsTime =
							sessionData.usedHintsTime + parseInt(element);
					});
				});
			} else {
				sessionData.usedHintsTime = 0;
				sessionData.usedHintsCount = 0;
			}

			sessionData.minus_for_hints = sessionData.usedHintsTime;
			//   console.log(sessionData.usedHintsTime);

			// score_normal_minus_hints
			sessionData.score_normal_minus_hints =
				sessionData.score_from_normal_riddles - sessionData.minus_for_hints;

			// manual modifier
			sessionData.score_from_manual_modifier = sessionData.session
				.manualModifier
				? Number(sessionData.session.manualModifier)
				: 0;

			// wrong answers penalty
			const penalty_from_wrong_answers = calculatePenaltyByRiddle(
				sessionData.wrongAnswers,
			);
			// console.log("Total:", penalty_from_wrong_answers.totalPenalty);
			// console.table(penalty_from_wrong_answers.perRiddle);

			sessionData.totalScore =
				sessionData.score_from_normal_riddles +
				sessionData.score_from_bonus_riddles +
				sessionData.score_normal_minus_hints +
				sessionData.score_bonus_from_time -
				Math.floor(penalty_from_wrong_answers.totalPenalty) +
				sessionData.score_from_manual_modifier;
			// console.log(
			// 	sessionData.totalScore,
			// 	sessionData.score_from_normal_riddles,
			// 	sessionData.score_from_bonus_riddles,
			// 	sessionData.score_normal_minus_hints,
			// 	sessionData.score_bonus_from_time,
			// 	sessionData.session.manualModifier,
			// 	Math.floor(penalty_from_wrong_answers.totalPenalty),
			// 	sessionData.score_from_manual_modifier
			// );

			sessionData.totalTime =
				sessionData.duration + sessionData.usedHintsTime * 60;
			sessionData.totalDays = Math.floor(sessionData.totalTime / 86400);
			sessionData.totalHours = Math.floor(
				(sessionData.totalTime % 86400) / 3600,
			);
			sessionData.totalMinutes = Math.floor(
				((sessionData.totalTime % 86400) % 3600) / 60,
			);
			sessionData.totalSeconds = Math.floor(
				((sessionData.totalTime % 86400) % 3600) % 60,
			);

			loader = false;
			getGameConclusion();

			// todo - remove
			// console.warn(sessionData.wrongAnswers);
		});
		// console.warn('Listener started!');
	}

	function calculatePenaltyByRiddle(wrongAnswers) {
		const bands = [
			{ min: 1, max: 3, penalty: 1.0 },
			{ min: 4, max: 6, penalty: 1.1 },
			{ min: 7, max: 10, penalty: 1.13 },
			{ min: 11, max: 15, penalty: 1.16 },
			{ min: 16, max: 25, penalty: 1.2 },
			{ min: 26, max: 40, penalty: 1.25 },
			{ min: 41, max: 60, penalty: 1.3 },
			{ min: 61, max: Infinity, penalty: 1.6 },
		];

		let totalPenalty = 0;
		const perRiddle = {};

		for (const riddleId in wrongAnswers) {
			const playerMap = wrongAnswers[riddleId];
			let riddleWrongCount = 0;

			for (const playerId in playerMap) {
				riddleWrongCount += playerMap[playerId].length;
			}

			if (riddleWrongCount === 0) continue;

			const band = bands.find(
				(b) => riddleWrongCount >= b.min && riddleWrongCount <= b.max,
			);
			const rawPenalty = riddleWrongCount * band.penalty;
			const cappedPenalty = Math.min(100, Math.round(rawPenalty * 100) / 100);

			perRiddle[riddleId] = {
				wrongAnswers: riddleWrongCount,
				multiplier: band.penalty,
				rawPenalty: Math.round(rawPenalty * 100) / 100,
				cappedPenalty,
			};

			totalPenalty += cappedPenalty;
		}

		return {
			totalPenalty: Math.round(totalPenalty * 100) / 100,
			perRiddle,
		};
	}

	async function getGameConclusion() {
		if (sessionData.current_task !== "conclusion") {
			console.log("Transfering to somewhere else?");
		} else {
			const taskRef = doc(
				db,
				"games",
				sessionData.game.gid,
				"gamedata",
				sessionData.current_task,
			);
			// console.log('games', sessionData.game.gid, 'gamedata', sessionData.current_task);
			const conclRefSnap = await getDoc(taskRef);
			if (conclRefSnap.exists()) {
				gameData.conclData = conclRefSnap.data();

				if (gameData.conclData.hidePoint !== undefined) {
					hideResult = gameData.conclData.hidePoint;
				} else {
					hideResult = false;
				}
				// console.log(gameData.conclData.hidePoint);
				// console.log(gameData.conclData.hideMessage);

				background = gameData.conclData.background;
				// console.log(gameData.conclData);
				loader = false;
				document.body.classList.remove("noscroll");
			} else {
				background = false;
				console.log(
					"The story for this game can't be found! Contact admin, but keep in mind that it's not a big issue!",
				);
			}
		}
	}

	async function backToHome() {
		const userRef = doc(db, "users", user.uid);
		localStorage.removeItem("showConclusion");
		// deleteField()
		await updateDoc(
			userRef,
			{
				showConclusion: deleteField(),
				hasActiveSession: false,
			},
			{ merge: true },
		).then(() => {
			dispatch("state", "login");
		});
	}
</script>

<header
	class="box-border flex justify-between h-20 text-base bg-blue-100 obelisk"
>
	<img
		class="hidden h-full max-h-full p-4 xs:block"
		src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
		alt={ui.game.footer.vendor}
	/>
	<img
		class="block h-full max-h-full p-4 xs:hidden"
		src="/img/svg/logo-icon.svg"
		alt={lang === "bg" ? "Вътрешен Глас" : "Inner Voice"}
	/>
	<button
		class=" ghost icon"
		style="margin-left:auto; margin-right:0"
		on:click={() => (
			(showLangSelector = false), (showHelpInfo = !showHelpInfo)
		)}
		title={ui.game.header.help_title}
	>
		{#if showHelpInfo}
			<i
				class="fa-solid fa-times fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{:else}
			<i
				class="fa-solid fa-circle-question fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{/if}
	</button>
	<button
		class="ghost icon"
		on:click={() => (
			(showHelpInfo = false), (showLangSelector = !showLangSelector)
		)}
		title={ui.game.header.lang_title}
	>
		{#if showLangSelector}
			<i
				class="fa-solid fa-times fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{:else}
			<i
				class="fa-solid fa-language fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{/if}
	</button>
	{#if showLangSelector}
		<div
			transition:slide
			class="absolute right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90"
		>
			<button on:click={() => ((lang = "bg"), (showLangSelector = false))}
				>Български (Bulgarian)</button
			>
			<button on:click={() => ((lang = "en"), (showLangSelector = false))}
				>English (Английски)</button
			>
		</div>
	{/if}
	{#if showHelpInfo}
		<div
			transition:slide
			class="absolute right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90 p-[10px] max-w-full"
		>
			<h3>{ui.help.title}</h3>
			<p>{ui.help.description}</p>

			<a href={ui.help.messenger_link}>{ui.help.messenger}</a>
			<a href={ui.help.instagram_link}>{ui.help.instagram}</a>
			<a href={ui.help.email_link}>{ui.help.email}</a>
		</div>
	{/if}
</header>
<main class="grid text-center obelisk place-content-center place-items-center">
	{#if loader == false && sessionData.session}
		<div
			transition:slide
			class=" role-{sessionData?.session.players[user.uid]
				.role} variant-{sessionData?.teamVariant
				? sessionData?.teamVariant
				: 'default'} contents"
		>
			{#if gameData.conclData}
				{#if gameData.conclData.customStyling}
					{@html gameData.conclData.customStyling}
				{/if}
			{/if}
			{#if sessionData.session.exodus}
				<h1 class="max-w-3xl">
					{ui.conclusion.sorry_pre}{user.name}{ui.conclusion.sorry_post}
				</h1>
				<h2>{ui.conclusion.sorry_description}</h2>
				<User name={user.name} photo={user.photo} />

				{#if gameData.conclData}
					{#if gameData.conclData.story_exodus}
						<br />
						<div class="obelisk-def">
							<!-- <SvelteMarkdown source={gameData.conclData.story.replaceAll('\\n', '\n')} /> -->
							{@html gameData.conclData.story_exodus}
						</div>
						<br />
					{/if}
				{/if}
			{:else}
				<h1 class="max-w-3xl">
					{ui.conclusion.congrats_pre}{user.name}{ui.conclusion.congrats_post}
				</h1>
				<h3 class="mt-1">{ui.conclusion.congrats_description}</h3>
				<br />

				<div
					class="flex flex-wrap gap-5 place-self-center place-content-center place-items-center"
				>
					<div>
						<div class="flex justify-center place-self-center" id="game_time">
							<i class="fa-solid fa-stopwatch input-icon" />
							<span class="text-center place-self-center igroup-text">
								{#if sessionData.durationDays}
									{sessionData.durationDays < 10
										? "0" + sessionData.durationDays
										: sessionData.durationDays}
									{sessionData.durationDays == 1
										? ui.global.time.day_long
										: ui.global.time.days_long},
								{/if}
								{#if sessionData.durationHours}
									{sessionData.durationHours < 10
										? "0" + sessionData.durationHours
										: sessionData.durationHours} :
								{/if}
								{#if sessionData.durationMinutes || sessionData.durationMinutes === 0}
									{sessionData.durationMinutes < 10
										? "0" + sessionData.durationMinutes
										: sessionData.durationMinutes} :
								{/if}
								{#if sessionData.durationSeconds || sessionData.durationSeconds === 0}
									{sessionData.durationSeconds < 10
										? "0" + sessionData.durationSeconds
										: sessionData.durationSeconds}
								{/if}
							</span>
						</div>
					</div>
					<div>
						<div class="flex justify-center place-self-center" id="game_hints">
							<i class="fa-solid fa-lightbulb input-icon" />
							<span class="text-center place-self-center igroup-text">
								{#if sessionData.usedHintsCount || sessionData.usedHintsCount === 0}
									{sessionData.usedHintsCount}
									{sessionData.usedHintsCount == 1
										? ui.conclusion.used_hint
										: ui.conclusion.used_hints}
								{/if}
							</span>
						</div>
					</div>
				</div>
				{#if !hideResult || overwriteHide}
					<br />
					<p>{ui.conclusion.your_score}</p>

					<!-- {gameData} -->
					<br />
					<!-- {gameData.conclData.hidePoint} -->

					<!-- hints used -->
					<div
						class="flex justify-center text-4xl place-self-center"
						id="game_score"
					>
						<i
							class="fa-solid fa-trophy input-icon secondary w-[70px!important] leading-[inherit!important]"
						/>

						<!-- 3xl - 66px -->

						<span class="text-center place-self-center secondary igroup-text">
							{#if sessionData.usedHintsCount || sessionData.usedHintsCount === 0}
								{sessionData.totalScore}
								{sessionData.totalScore == 1
									? ui.conclusion.point
									: ui.conclusion.points}
								<!-- score % 10? -->
							{/if}
						</span>
					</div>

					{#if !showGenerator}
						<button
							on:click={() => {
								showGenerator = !showGenerator;
								logEvent(analytics, "score_card_generated");
							}}
							class="secondary"
							id="share_score_button"
						>
							<i
								class="fa-solid fa-share-from-square"
								data-position="left"
							/>{ui.conclusion.share_your_score}
						</button>
					{:else}
						<ScoreGenerator
							{lang}
							{sessionData}
							{background}
							{gameData}
							{analytics}
							text={ui.conclusion}
						/>
					{/if}
				{:else if gameData.conclData}
					{#if gameData.conclData.hideMessage}
						<br />
						<div class="obelisk-def">
							<!-- <SvelteMarkdown source={gameData.conclData.story.replaceAll('\\n', '\n')} /> -->
							{@html gameData.conclData.hideMessage}
						</div>
						<br />
					{/if}
				{/if}

				{#if gameData.conclData}
					<br />
					<div class="obelisk-def">
						<!-- <SvelteMarkdown source={gameData.conclData.story.replaceAll('\\n', '\n')} /> -->
						{@html gameData.conclData.story}
					</div>
					<br />
				{/if}
			{/if}

			<br />

			<p>{ui.conclusion.share_how_to_be_better}</p>
			<button
				on:click={() => window.open(ui.conclusion.send_review_link, "_blank")}
				class="secondary"
			>
				<i class="fa-solid fa-envelope" data-position="left" />{ui.conclusion
					.send_review}
			</button>
			<br />

			<button class="justify-center place-self-center" on:click={backToHome}>
				<i class="fa-solid fa-circle-left" data-position="left" />{ui.conclusion
					.back_home}
			</button>
		</div>
	{/if}
</main>
<GameFooter {lang} />

<style>
</style>
